const routesMapping = [
  {
    path: "/",
    sidebarName: "meeting",
  },
  {
    path: "/admin",
    sidebarName: "meeting",
  },
  {
    path: "/global-admin",
    sidebarName: "meeting",
  },
  {
    path: "/meetings",
    sidebarName: "meeting",
  },
  {
    path: "/meetings/:meetingId",
    sidebarName: "meeting",
  },
  {
    path: "/meetings/:meetingId/new",
    sidebarName: "meeting",
  },
  {
    path: "/client",
    sidebarName: "meeting",
  },
  {
    path: "/home",
    sidebarName: "meeting",
  },
  {
    path: "/meeting-scheduler/client1",
    sidebarName: "meeting",
  },
  {
    path: "/contacts",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id",
    sidebarName: "meeting",
  },
  {
    path: "/client-history1",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/cashflow",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/fact-find",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/fact",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/file-notes",
    sidebarName: "meeting",
  },
  {
    path: "/fact",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/graph",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/new-meeting",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/email",
    sidebarName: "meeting",
  },
  {
    path: "/client/:id/e-sign",
    sidebarName: "meeting",
  },
  {
    path: "/blue-zinc/my-documents",
    sidebarName: "blue_zinc",
  },
  {
    path: "/blue-zinc/upload-documents",
    sidebarName: "blue_zinc",
  },
  {
    path: "/blue-zinc/my-application",
    sidebarName: "blue_zinc",
  },
  {
    path: "/scheduler/schedule-meeting",
    sidebarName: "schedule_meet",
  },
  {
    path: "/scheduler/dashboard",
    sidebarName: "schedule_meet",
  },
  {
    path: "/customers/dashboard",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/customers",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/customers/:trust",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/select/labeling",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/labeling",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/labeling/cropped",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/customers/:trust/review-document",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/customers/:trust/link-document",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/customers/:trust/link-or-unlink-party-document",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/customers/:trust/review-and-complete-document",
    sidebarName: "kyc_dashboard",
  },
  {
    path: "/validation/parking-signs-select",
    sidebarName: "sign_detection",
  },
  {
    path: "/validation/parking-signs",
    sidebarName: "sign_detection",
  },
  {
    path: "/object-modeling/:moduleId",
  },
  {
    path: "/credit-risk",
    sidebarName: "credit_risk",
  },
  {
    path: "/credit-risk/score",
    sidebarName: "credit_risk",
  },
  {
    path: "/invoices",
    sidebarName: "invoices",
  },
  {
    path: "/add-invoices",
    sidebarName: "invoices",
  },
  {
    path: "/invoices/:invoiceId",
    sidebarName: "invoices",
  },
  {
    path:"/prospo-chat",
    sidebarName: "prospo_chat",
  },
];

export default routesMapping;
